/** Page-level gate for Master Data menu and /master-data, /system-settings routes. */
export const MASTER_DATA_PAGE_PERMISSION = "PagesAdministration.MasterData"

const CONTRACT_INQUIRY_MODULE_PREFIX = "PagesAdministration.ContractInquiry."

/** True when user has any ContractInquiry (Sổ thu chi) permission. */
export function hasContractInquiryFunctionalAccess(
  grantedPermissions: Record<string, unknown> | undefined
): boolean {
  if (!grantedPermissions) {
    return false
  }

  return Object.keys(grantedPermissions).some((name) =>
    name.startsWith(CONTRACT_INQUIRY_MODULE_PREFIX)
  )
}

export function hasGrantedPermissionWithPrefix(
  grantedPermissions: Record<string, unknown> | undefined,
  prefix: string
): boolean {
  if (!grantedPermissions) {
    return false
  }

  const childPrefix = `${prefix}.`
  return Object.keys(grantedPermissions).some(
    (name) => name === prefix || name.startsWith(childPrefix)
  )
}

/** Auto-include page permission when any Master Data child is granted (UI cannot tick the root). */
export function ensureMasterDataPagePermission(permissionNames: string[]): string[] {
  const hasMasterDataAccess = permissionNames.some(
    (name) =>
      name === MASTER_DATA_PAGE_PERMISSION ||
      name.startsWith(`${MASTER_DATA_PAGE_PERMISSION}.`)
  )

  if (
    hasMasterDataAccess &&
    !permissionNames.includes(MASTER_DATA_PAGE_PERMISSION)
  ) {
    return [...permissionNames, MASTER_DATA_PAGE_PERMISSION]
  }

  return permissionNames
}
